export default {
      id: "facebook-icon-usage",
      viewBox: "0 0 10 21",
      url: "/" + "sprite.svg#facebook-icon",
      toString: function () {
        return this.url;
      }
    }